import type { JSX } from 'react';
import { Alert, Button, CopyButton, Group, Stack, Text, TextInput } from '@mantine/core';
import type { IssuedLink } from '../api';
import { formatDateTime } from '../format';

/**
 * Shows a freshly issued one-time link. It is shown exactly once: the server
 * keeps only a hash, so closing this without copying means issuing a new one.
 */
export function LinkResult({
  issued,
  purpose,
  onDone,
}: {
  issued: IssuedLink;
  purpose: string;
  onDone: () => void;
}): JSX.Element {
  return (
    <Stack>
      {issued.mailed && (
        <Alert color="green" variant="light" py={6}>Per E-Mail versendet. Der Link steht zusätzlich hier, falls die Mail nicht ankommt.</Alert>
      )}
      <Text size="sm">{purpose}</Text>
      <Group gap="xs" wrap="nowrap" align="flex-end">
        <TextInput
          readOnly
          value={issued.link}
          style={{ flex: 1 }}
          onFocus={(event) => event.currentTarget.select()}
          aria-label="Link"
        />
        <CopyButton value={issued.link}>
          {({ copied, copy }) => (
            <Button onClick={copy} color={copied ? 'green' : undefined} w={110}>
              {copied ? 'Kopiert' : 'Kopieren'}
            </Button>
          )}
        </CopyButton>
      </Group>
      <Alert color="yellow" variant="light">
        Gültig bis {formatDateTime(issued.expiresAt)} und nur einmal verwendbar. Wer den
        Link hat, kann das Konto einrichten – geben Sie ihn auf einem Weg weiter, dem Sie
        vertrauen. PST verschickt keine E-Mails, und dieser Link wird nicht noch einmal
        angezeigt.
      </Alert>
      <Button variant="default" onClick={onDone}>Fertig</Button>
    </Stack>
  );
}
